import Image from "next/image";
import React, { FC } from "react";

interface TradingSectionProps {}

const TradingSection: FC<TradingSectionProps> = () => {
  return (
    <div>
      <div className="mx-4 sm:mx-16 xl:mx-40 2xl:mx-96 pb-8 lg:pt-16  ">
        <div className="flex flex-col-reverse lg:flex-row">
          <div className="lg:w-1/2  ">
            <div className=" lg:w-11/12 xl:w-10/12 2xl:w-11/12 text-center lg:text-left -mt-16 lg:-mt-0">
              <div className="w-11/12  mx-auto lg:ml-0 ">
                <p className="text-xl  sm:text-4xl  2xl:text-5xl font-semibold future-letter-spacing2 future-text-black leading-snug xl:future-line-height mt-8 sm:mt-12">
                  A simple way to earn in a bear or bull market.
                </p>
                <p className="text-sm  sm:text-2xl tracking-wide sm:font-thin future-text-gray mt-4 sm:mt-8 leading-snug future-letter-spacing3 sm:future-letter-spacing2">
                  Most traders buy bitcoin with the hope to sell at a higher
                  price. But when the market goes opposite, some sell at a loss.
                  We’ve simplified futures investing so you can earn in an
                  uptrend or downtrend.
                </p>
              </div>
            </div>
          </div>
          <div className="lg:w-1/2">
            <div className="flex justify-center lg:justify-end w-full pt-8 lg:pt-0">
              <div className="relative overflow-y-hidden h-64 w-64 sm:h-[30rem] sm:w-[50rem] -mt-12">
                <Image src="/illustrations/simplified.svg" layout="responsive" width={"100%"} height={"100%"}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingSection;
